import BasePostGridList from "@PegasusCore/pegasus-one-post-grid-list/src/script";

class PostGridList extends BasePostGridList {
    init() {
        super.init();
    }

    getSelectedFilterText(filter){
        const filterResults = this.currentFilters[`filter-t-${filter}`];
        let filtersArray = [];
        if(filterResults){
            filtersArray = filterResults.split(',');
        }

        const escapeHtml = (unsafe) => {
            return unsafe.replaceAll('&', '&amp;').replaceAll('<', '&lt;').replaceAll('>', '&gt;').replaceAll('"', '&quot;').replaceAll("'", '&#039;');
        }

        if(filtersArray.length === 1){
            let sector = filtersArray[0];
            sector =  escapeHtml(sector);
            const text = this.$root.querySelector(`#${sector}`).textContent;
            return text;
        }

        return 'Multiple';
    }
}

document.addEventListener('alpine:init', () => {
    Alpine.data('postGridList', () => new PostGridList())
});
